export default function getInGridElements({
    index,
    showQuickFilters,
    showTipsheet,
    nbOfProductCards,
    quickFilters,
    tipsheet,
    maxPercentageOfInGridElements,
    minHitsLength,
    listingOffset,
    firstPageLength,
}) {
    const elementsPageLength =
        nbOfProductCards === firstPageLength
            ? nbOfProductCards + listingOffset
            : nbOfProductCards;
    const typedTipsheet = { type: 'tipsheet', ...tipsheet };
    const maxElements = Math.floor(
        (maxPercentageOfInGridElements / 100) * elementsPageLength,
    );
    let elements = [];
    if (nbOfProductCards > minHitsLength) {
        if (showQuickFilters) elements = [...quickFilters];
        elements = elements.slice(0, maxElements);

        if (showTipsheet) {
            if (elements.length < maxElements) elements.push(typedTipsheet);
            else {
                elements[elements.length - 1] = typedTipsheet;
            }
        }
    }

    if (nbOfProductCards <= minHitsLength && index === nbOfProductCards) {
        if (showTipsheet) elements = typedTipsheet;
        else if (showQuickFilters && quickFilters?.lentgh > 0)
            elements = quickFilters[0];
    }

    return elements;
}
